import React from 'react';
import { Star } from 'lucide-react';
export function QuickTestimonials() {
  const testimonials = [{
    initials: 'SL',
    quote: 'Organicé todo el mes en una tarde. Nunca más llego a clase sin saber qué dar.',
    author: 'Soledad L., Buenos Aires',
    role: 'Profesora de Italiano en Instituto Privado'
  }, {
    initials: 'MR',
    quote: 'Mis alumnos de nivel inicial mejoraron su producción oral desde la primera semana con el Tomo 3.',
    author: 'Marcela R., Córdoba',
    role: 'Profesora Particular de Italiano'
  }, {
    initials: 'GP',
    quote: 'Antes tardaba 2 horas armando una clase. Ahora son 10 minutos.',
    author: 'Gastón P., Rosario',
    role: 'Profesor de Italiano Independiente'
  }];
  return <section className="pt-2 pb-20 md:pt-6 md:pb-24 bg-[#1F2A24]" data-id="element-259">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-260">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-id="element-261">
          {testimonials.map((t, i) => <div key={i} className="bg-[#2A3530] rounded-2xl p-6 md:p-7 border border-white/5" data-id="element-262">
              <div className="flex items-center mb-5" data-id="element-263">
                <div className="w-10 h-10 rounded-full bg-[#C76F4A] text-white flex items-center justify-center font-bold text-xs mr-3 flex-shrink-0" data-id="element-264">
                  {t.initials}
                </div>
                <div className="flex text-[#E8A86A]" data-id="element-265">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-266" />)}
                </div>
              </div>
              <p className="text-white text-[15px] md:text-base leading-relaxed mb-5" data-id="element-267">
                "{t.quote}"
              </p>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-268">
                — {t.author} | {t.role}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}